function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Text, TSpan, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 43.478,
  height: 43.458,
  x: 0.5,
  y: 0.5,
  rx: 13
}), /*#__PURE__*/React.createElement(Text, {
  fill: "#FFF",
  fontFamily: "HalisR-Bold, Halis R",
  fontSize: 16,
  fontWeight: "bold",
  letterSpacing: -0.333
}, /*#__PURE__*/React.createElement(TSpan, {
  x: 18.102,
  y: 27.418
}, "2")), /*#__PURE__*/React.createElement(G, {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  opacity: 0.2
}, /*#__PURE__*/React.createElement(Path, {
  d: "M9.035 27.374V12.939a3.9 3.9 0 013.9-3.9h13.433m.172 0h4.436a3.901 3.901 0 013.899 3.9v4.435m0 .171V30.98a3.9 3.9 0 01-3.9 3.899H16.541"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M17.368 34.879h-4.433a3.9 3.9 0 01-3.9-3.9v-4.434"
})));

function SvgIconSecondPlan(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _ref);
}

export default SvgIconSecondPlan;